module.exports = __webpack_public_path__ + "assets/img/free_35.230b1030.png";